// src/components/NavBar.jsx
import React, { useEffect, useState } from 'react';
import './NavBar.css';

const NavBar = () => {
    const [visible, setVisible] = useState(true);
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            setVisible(e.clientY <= 60);
        };
        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    const handleLinkClick = () => {
        if (mobileOpen) setMobileOpen(false);
    };

    return (
        <nav className={`navbar ${visible ? 'visible' : 'hidden'}`}>
            <div className="logo">NIRVSAI</div>

            {/* Hamburger icon */}
            <div
                className={`hamburger ${mobileOpen ? 'open' : ''}`}
                onClick={() => setMobileOpen(!mobileOpen)}
            >
                <span></span>
                <span></span>
                <span></span>
            </div>

            <ul className={`nav-links ${mobileOpen ? 'open' : ''}`}>
                {['Home', 'About', 'Work', 'Contact'].map((item, idx) => (
                    <li key={idx}>
                        <a
                            href={item === 'Home' ? '/' : `#${item.toLowerCase()}`}
                            onClick={handleLinkClick}
                        >
                            {item}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default NavBar;
